import { useTimeout } from '@fuse/hooks';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
	delay?: number;
};
const FuseLoading = ({ delay }: Props) => {
	const { t, ready } = useTranslation(undefined, { useSuspense: false });

	const [showLoading, setShowLoading] = useState(!delay);

	useTimeout(() => {
		setShowLoading(true);
	}, delay);

	if (!showLoading) {
		return null;
	}

	return (
		<div className="flex flex-1 flex-col items-center justify-center">
			<Typography className="text-20 mb-16" color="textSecondary">
				{ready ? t('Loading...') : '\u00A0'}
			</Typography>
			<LinearProgress className="w-xs" color="secondary" />
		</div>
	);
};

export default FuseLoading;
